module.exports = __webpack_public_path__ + "pc/img/award2020_02.77803a84.png";